module.exports = __webpack_public_path__ + "static/img/face24.788856d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face24.jpg
// module id = 1Xkh
// module chunks = 0